import { render, staticRenderFns } from "./GeoZoneReassignmentsPopup.vue?vue&type=template&id=0b8d3df3"
import script from "./GeoZoneReassignmentsPopup.vue?vue&type=script&lang=ts"
export * from "./GeoZoneReassignmentsPopup.vue?vue&type=script&lang=ts"
import style0 from "./GeoZoneReassignmentsPopup.vue?vue&type=style&index=0&id=0b8d3df3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports